import './BattleStatGamePad.scss';

import FSDropPanel from "../../1. Core/Controls/DropPanel/FSDropPanel";
import NP from "../../1. Core/NP";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import Label from "../../1. Core/Controls/Label/Label";
import {IBattleEvent, ITournament} from "../../10. Battle/Util";
import Button from "../../1. Core/Controls/Button/Button";
import {ServerAPI} from "../../1. Core/ServerAPI";
import UserInfo, {IUserInfo} from "../../1. Core/UserInfo";
import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import Select from "../../1. Core/Controls/Select/Select";
import {IBattle} from "../../10. Battle/types";
import moment = require("moment");
import {EndBoutDialog} from "../EndBoutDialog";
/**
 * Для бокса
 */
export default class BattleStatGamePad extends FSDropPanel {
	protected _appBar: TopAppBar;
	protected _gamePadLeftNode: HTMLElement;
	protected _gamePadRightNode: HTMLElement;
	protected _Battle: IBattle;
	protected _leftPadLabels: Label[];
	protected _rightPadLabels: Label[];
	protected _redCurrentEvent: IBattleEvent;
	protected _blueCurrentEvent: IBattleEvent;
	protected _events: IBattleEvent[];
	protected _Round: number;
	protected _redLabel: Label;
	protected _blueLabel: Label;
	protected _historyLabel: Label;
	protected _redActiveButton: Label;
	protected _blueActiveButton: Label;
	protected _Sequence: number;
	protected _nextRound: Button;
	protected _LastEvDate: Date;
	protected _CanClickOneButton: boolean;
	protected _ButtonHoldProcessed: boolean; //признак того, что зажатие кнопки обработано в коде
	protected _IsHideButtonVisible: boolean;
	private _RedGamePadeChecked: number;
	private _BlueGamePadeChecked: number;
	private _CheckEditLockTimer: number;
	private _SendEventsTimer: number;
	private _PressedButtonChecked: number;
	private _urlId: string

	private _roundTimerNode: HTMLElement;
	private _roundTimerLbl: Label;
	protected _RoundStarted: number;
	protected _IsPause: boolean;
	protected _PauseLength: number;
	protected _PauseStarted: number;

	constructor(settings: object)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		this._Battle = null;
		this._events = [];
		this._Round = 1;
		this._Sequence = 1;
		this._CheckEditLockTimer = null;
		this._SendEventsTimer = null;
		this._PressedButtonChecked = null;
		this._ButtonHoldProcessed = false;
		this._IsHideButtonVisible = true;
		super._initFields(settings);
	}

	_render()
	{

		super._render();
		this.addClass('game-pad-dropdown box-gamepad');


		this._appBar = new TopAppBar({
			Class: 'top-app-bar--white',
			Caption: NP.RM.getString('BattleStatistics'),
			MainButton: this._IsHideButtonVisible ? {
				FontImage: NP.FontImages.close,
				EvClick: () => this.hide()
			} : undefined,
			RightItems: [
				new Button({
					RK: 'Hide Game pads',
					Value: true,
					EvClick: (btn: Button) => this.switchVisiblePads(btn)
				}),
				this._nextRound = new Button({
					Content: NP.RM.getString('NextRound') + ' ' + this._Round,
					EvClick: () => {
						if (!this._RoundStarted)
							this.startRound();
						else
							this.nextRound();
					}
				}),
				new Button({
					RK: 'BoutEnd',
					EvClick: () => this.endBattle()
				})]
		});


		this._appBar.putToNode(this._root, this._contentDomNode);

		this._gamePadLeftNode = NP.createNode(this._contentDomNode, 'game-pad__left-node');
		this._redLabel = new Label({
			Content: this._Battle.RedName + ` (${NP.RM.getString('Red')})`,
			ParentNode: this._gamePadLeftNode,
			Class: 'game-pad__red-label'
		});
		NP.createNode(this._gamePadLeftNode, 'game-pad__left-node__img-node');
		this._leftPadLabels = this._createLabels(this._gamePadLeftNode, true);

		this._historyLabel = new Label({
			ParentNode: this._contentDomNode,
			Class: 'game-pad__history'
		});

		this._gamePadRightNode = NP.createNode(this._contentDomNode, 'game-pad__right-node');
		this._blueLabel = new Label({
			Content: this._Battle.BlueName + ` (${NP.RM.getString('Blue')})`,
			ParentNode: this._gamePadRightNode,
			Class: 'game-pad__blue-label'
		});
		NP.createNode(this._gamePadRightNode, 'game-pad__right-node__img-node');
		this._rightPadLabels = this._createLabels(this._gamePadRightNode, false);


		this._roundTimerNode = NP.createNode(this._contentDomNode, 'round-timer');
		this._roundTimerLbl = new Label({
			ParentNode: this._roundTimerNode,
			Class: 'round-timer__lbl',
			Content: 'Not started'
		});

		this.setRedStartState();
		this.setBlueStartState();
		this.updateStatus();
	}

	showBlockDialog = (blockerSettings: IUserInfo): boolean =>
	{

		if (!blockerSettings)
			return false;

		let blocker: UserInfo = new UserInfo(blockerSettings);
		let curUser = NP.getCurrentUser();
		let isYou = curUser.getKey() === blocker.getKey();
		let emailPart = !isYou ? NP.escapeHTML(`<${blocker.getEmail()}>`) : '';
		let unlockPart = isYou ? `<br />${NP.RM.getString('UnlockQuestion')}` : '';
		let dlg = new Dialog({
			ShowHeader: true,
			Caption: NP.RM.getString('Error'),
			Content: `${NP.RM.getString('BattleLockMessage')}${blocker.getViewName()}${emailPart}${unlockPart}`,
			AutoDestroy: true,
			ShowButtons: true,
			EvOkButtonClick: isYou ? this.onBlockDialogOkButtonClick : undefined,
		});
		if (!isYou)
			dlg.getCancelButton().setIsVisible(false);
		dlg.show();
		return true;
	};

	onBlockDialogOkButtonClick = () =>
	{
		ServerAPI.post(`/battle/${this._Battle.Id}/endEditBattleData`).then(() =>
		{
			NP.editingBattleId = null;
			this.show();
		});
		window.clearInterval(this._CheckEditLockTimer);
	}

	show(left?: number, top?: number, notCreateFrame?: boolean, skipConfirm?: boolean)
	{
		if (!skipConfirm)
		{
			let dlg = new Dialog({
				Content: [
					new Label({RK: 'IsGlobal'}),
					new Select({
						Items: [
							{RK: 'No', Value: ''},
							{Content: 'Current', Value: 'current'},
							{Content: 'Current2', Value: 'current2'},
							{Content: 'Current3', Value: 'current3'},
							{Content: 'CurrentRCC', Value: 'currentRCC'},
							{Content: 'CurrentSS', Value: 'currentSS'}
						]
					})
				],
				EvOkButtonClick: () =>
				{
					let value = dlg.getContent()[1].getValue();
					if (value)
					{
						this._urlId = value;
						this.show(left, top, notCreateFrame, true);
					}
					else
					{
						super.show();
					}
				}
			});

			if (this._Battle.EventId)
			{
				ServerAPI.get<ITournament[]>(`/tournaments`).then(ev =>
				{
					let select = dlg.getContent()[1]
					let t = ev.find(t => t.Id == this._Battle.TournamentId);
					if (t?.Current) {
						if (!select.getItems().find(it => it.Value == t.Current))
						{
							select.addItem({Content: t.Current, Value: t.Current})
						}
						select.setValue(t?.Current)
					}
				})
			}

			dlg.show();
			dlg.getCancelButton().setIsVisible(false);

			return true;
		}

		ServerAPI.post(`/battle/${this._Battle.Id}/startEditBattleData?url=${this._urlId}`).then(() =>
		{

			super.show();
			// if (this.showBlockDialog(blocker))
			// 	return;
			//
			// const checkInterval = 10000;
			// NP.editingBattleId = this._Battle.Id;
			//
			// if (this._CheckEditLockTimer != null)
			// 	window.clearInterval(this._CheckEditLockTimer);
			// this._CheckEditLockTimer = window.setInterval(() =>
			// {
			// 	ServerAPI.post(`/battle/${this._Battle.Id}/checkIsBattleDataLocked?url=${this._urlId}`).then((isLocked: boolean) =>
			// 	{
			// 		if (!isLocked)
			// 		{
			// 			ServerAPI.post(`/battle/${this._Battle.Id}/startEditBattleData?url=${this._urlId}`)
			// 		}
			// 	});
			// }, checkInterval);

		});
		return true;
	}

	_refreshRoundTimer()
	{
		if (!this._IsPause)
			this._roundTimerLbl.setContent(this.getFormattedCurrentRoundTime());
	}

	getFormattedCurrentRoundTime()
	{
		let roundTimeSec = 0,
			 roundTimeMin = 0;
		if (this._RoundStarted)
		{
			let roundTimeMillis = (new Date).getTime() - this._RoundStarted - this._PauseLength;
			roundTimeSec = Math.round(roundTimeMillis / 1000);
			roundTimeMin = Math.floor(roundTimeSec / 60);
		}
		let sec = roundTimeMin ? roundTimeSec % (roundTimeMin * 60) : roundTimeSec,
			 displayMin = roundTimeMin < 10 ? '0' + roundTimeMin : '' + roundTimeMin,
			 displaySec = sec < 10 ? '0' + sec : '' + sec;

		if (roundTimeMin >= this._Battle.RoundLength)
		{
			return (this._Battle.RoundLength < 10 ? '0' + this._Battle.RoundLength : '' + this._Battle.RoundLength) + ':00';
		}

		return displayMin + ':' + displaySec;
	}



	hide()
	{
		ServerAPI.post(`/battle/${this._Battle.Id}/endEditBattleData`).then(() =>
		{
			NP.editingBattleId = null;
		});

		window.clearInterval(this._CheckEditLockTimer);
		super.hide();
	}

	switchVisiblePads(btn: Button)
	{
		if (btn.getValue())
		{
			btn.setValue(false);
			btn.setRK('Show Game pads');
			this._gamePadLeftNode.style.height = '30px';
			this._gamePadRightNode.style.height = '30px';
		}
		else
		{
			btn.setValue(true);
			btn.setRK('Hide Game pads');
			this._gamePadLeftNode.style.height = '';
			this._gamePadRightNode.style.height = '';
		}
	}

	trySendEvents(events: IBattleEvent[], attemptsCount?: number, callback?: Function)
	{
		if (attemptsCount == undefined)
			attemptsCount = 1;

		if (attemptsCount > 0)
		{
			attemptsCount -= 1;
			ServerAPI.post(`/box/${this._Battle.Id}/addBattleEvents`, events)
				 .then(() => callback && callback())
				 .catch(() => this.trySendEvents(events, attemptsCount, callback));
		}
	}

	sendCurrentEvents(clear?: boolean, callback?: Function)
	{
		this._refreshRoundTimer()
		if (this._events)
		{
			let eventsToSend: IBattleEvent[] = [];
			this._events.forEach(ev =>
			{
				if (!ev.IsSaved && (ev.Action && ev.Answer || ev.Answer == 'CL' || ev.Answer == 'Knockdown'))
				{
					eventsToSend.push(ev);
					ev.IsSaved = true;
				}
			});

			if (clear)
				this._events = [];

			if (eventsToSend.length > 0)
				this.trySendEvents(eventsToSend, 3, callback);
			else
				callback && callback();
		}
		else
			callback && callback();
	}

	// sendUpdateCurrentEvents(clear?: boolean)
	// {
	// 	ServerAPI.call("SportService.editBattleEvents", [this._events.filter(ev => ev.Action && ev.Answer || ev.Answer == 'CL' || ev.Answer == 'Knockdown')]);
	//
	// 	if (clear)
	// 		this._events = [];
	// }

	async endBattle()
	{

		await ServerAPI.post("/mma/setBattleEditMeta", {
			battleId: this._Battle.Id,
			round: this._Round,
			isRoundStarted: false
		});


		(new EndBoutDialog({
			Battle: this._Battle,
			LastEvent: this._events[this._events.length - 1],
			EndTimeStr: this._Battle.EndTime,
		})).show();

		this.hide();
		//NP.showMessage({Content: NP.RM.getString('BoutEndMsg')});
	}

	nextRound()
	{
		if (this._events.find(ev => ev.Round == this._Round))
		{
			this._Round++;
			this._nextRound.setContent(NP.RM.getString('NextRound') + ' ' + this._Round);
			this.sendCurrentEvents(true);
			this._historyLabel.setContent('');
		}
		this._RoundStarted = null
		this._PauseLength = 0;
		window.clearInterval(this._SendEventsTimer);

		this._roundTimerLbl.setContent('00:00')

		ServerAPI.post("/mma/setBattleEditMeta", {
			battleId: this._Battle.Id,
			round: this._Round,
			isRoundStarted: false
		})

		ServerAPI.post("/box/refreshBattleSeries")
	}

	startRound()
	{
		ServerAPI.post("/mma/setBattleEditMeta", {
			battleId: this._Battle.Id,
			round: this._Round,
			isRoundStarted: true
		})

		this._PauseLength = 0;
		this._RoundStarted = new Date().getTime()
		const saveInterval = 1000;
		if (this._SendEventsTimer != null)
			window.clearInterval(this._SendEventsTimer);
		this._SendEventsTimer = window.setInterval(() => this.sendCurrentEvents(), saveInterval);
	}

	_createLabels(gamePadNode: HTMLElement, isRed: boolean)
	{
		let res = [
			new Label({
				RK: 'UL',
				Value: 6
			}),
			new Label({
				RK: 'HL',
				Value: 4
			}),

			//виды защины
			new Label({
				RK: 'U',
				Value: 12,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'W',
				Value: 14,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'N',
				Value: 13,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'B',
				Value: 15,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'CL',
				Value: 3
			}),

			//Select
			new Label({
				RK: 'SelectLbl',
				Value: 8
			}),

			new Label({
				RK: 'Round',
				Value: 9
			}),

			new Label({
				RK: 'HR',
				Value: 5
			}),
			new Label({
				RK: 'UR',
				Value: 7
			}),

			//простые удары
			new Label({
				RK: 'J',
				Value: 2
			}),
			new Label({
				RK: 'C',
				Value: 1
			}),

			new Label({
				RK: 'Space',
				Value: 0
			}),

			//пропущенные
			//Tag это индекс оси
			new Label({
				RK: 'P1',
				Tag: 0,
				Value: -1,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'P2',
				Tag: 1,
				Value: -1,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'P3',
				Tag: 0,
				Value: 1,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'P4',
				Tag: 1,
				Value: 1,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'P5',
				Tag: 2,
				Value: -1,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'P6',
				Tag: 3,
				Value: -1,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'P7',
				Tag: 2,
				Value: 1,
				Data: 'IsAnswer'
			}),
			new Label({
				RK: 'P6',
				Tag: 3,
				Value: 1,
				Data: 'IsAnswer'
			})
		];

		res.forEach(lbl =>
		{
			lbl.addClass('game-pad__' + lbl.getRK());
			lbl.putToNode(gamePadNode);
			lbl.EvClick.add((sender: Label) =>
			{
				this._onGamePadClick(null, sender, isRed);
			}, this);
		});

		return res;
	}

	vibrate(gamepad: any)
	{
		if (gamepad)
			gamepad.vibrationActuator.playEffect("dual-rumble", {duration: 100, strongMagnitude: 1.0, weakMagnitude: 1.0});
	}

	updateHistory()
	{
		if (this._events.length)
		{
			let currentSequence = this._historyLabel.getValue() || 1,
				 ev = this._events[this._events.length - 1],
				 res = '',
				 historyRowClass = ev.ActionAthleteId == this._Battle.Red ? 'game-pad__history-row--red' : 'game-pad__history-row--blue';

			if (currentSequence != ev.Sequence)
			{
				let space = NP.createNode(this._historyLabel.getRoot(), historyRowClass);
				space.innerText = '---' + NP.RM.getString('Space') + '---';
				this._historyLabel.setValue(currentSequence + 1);
			}

			res += ev.ActionAthleteId == this._Battle.Red ? ev.Action : (ev.Answer || "_");
			res += '     ' + (ev.ActionAthleteId == this._Battle.Blue ? ev.Action : (ev.Answer) || "_");

			let span = NP.createNode(this._historyLabel.getRoot(), historyRowClass);
			span.innerText = res;

			this._historyLabel.getRoot().scrollTop = this._historyLabel.getRoot().scrollHeight;
		}
	}


	saveEvent(ev: IBattleEvent)
	{
		ev.ActionTS = moment().utc().format('YYYY-MM-DD HH:mm:ss.S');   //важно чтобы время на сервере и на клиенте совпадало
		ev.Time = '00:' + this.getFormattedCurrentRoundTime();
		this._events.push(ev);
		this.updateHistory();
	}

	setRedStartState()
	{
		this._redCurrentEvent = null;
		this._leftPadLabels.forEach(lbl => lbl.setEnabled(lbl.getData() != 'IsAnswer'));
	}

	setBlueStartState()
	{
		this._blueCurrentEvent = null;
		this._rightPadLabels.forEach(lbl => lbl.setEnabled(lbl.getData() != 'IsAnswer'));
	}

	_onGamePadClick(gamepad: Gamepad, label: Label, isRed: boolean, isButtonHold?: boolean)
	{
		if (!this._RoundStarted)
		{
			return this.vibrate(gamepad);
		}

		let actionId = label.getRK(),
			 isAnswer = label.getData() == 'IsAnswer';

		if (isButtonHold && !this._ButtonHoldProcessed)
		{
			this._ButtonHoldProcessed = true;
			return;
		}

		if (actionId == 'Round')
		{
			if (!this._RoundStarted)
				this.startRound();
			else
				this.nextRound();

			this.setRedStartState();
			this.setBlueStartState();
			return;
		}

		if (actionId == 'Space')
		{
			this._Sequence++;
			return;
		}

		let ev: IBattleEvent;

		if (isRed)
		{
			if (!this._redCurrentEvent)
				this._redCurrentEvent = {
					BattleId: this._Battle.Id,
					Round: this._Round,
					ActionAthleteId: this._Battle.Red,
					AnswerAthleteId: this._Battle.Blue,
					Sequence: this._Sequence
				} as any;

			ev = this._redCurrentEvent;
		}
		else
		{
			if (!this._blueCurrentEvent)
				this._blueCurrentEvent = {
					BattleId: this._Battle.Id,
					Round: this._Round,
					ActionAthleteId: this._Battle.Blue,
					AnswerAthleteId: this._Battle.Red,
					Sequence: this._Sequence
				} as any;

			ev = this._blueCurrentEvent;
		}

		if (ev.Action == actionId)
			return;

		if (actionId == 'CL')
		{
			this._Sequence++;
			ev.Action = actionId;
			this.saveEvent(ev);
			if (isRed)
				this.setRedStartState();
			else
				this.setBlueStartState();
		}
		else
		{

			if (this._LastEvDate == null)
				this._LastEvDate = new Date();
			//@ts-ignore
			else if ((new Date() - this._LastEvDate) > 1000)
			{
				this._Sequence++;
				ev.Sequence = this._Sequence;
			}

			if (!ev.Action)
			{
				if (isAnswer)
					return this.vibrate(gamepad);

				ev.Action = actionId;

				if (isRed)
					this._leftPadLabels.forEach(lbl => lbl.setEnabled(lbl.getData() == 'IsAnswer'));
				else
					this._rightPadLabels.forEach(lbl => lbl.setEnabled(lbl.getData() == 'IsAnswer'));
			}
			else
			{
				if (!isAnswer)
					return this.vibrate(gamepad);

				ev.Answer = actionId;

				this.saveEvent(ev);

				if (isRed)
					this.setRedStartState();
				else
					this.setBlueStartState();
			}
		}
	}

	checkGamePad(gamepad: Gamepad, labels: Label[], isRed: boolean)
	{
		//let state = '';
		let clickedLabel = null;

		for (let i = 0; i < gamepad.buttons.length; i++)
		{
			let val = gamepad.buttons[i] as any,
				 pressed = val == 1.0;
			if (typeof (val) == "object")
			{
				pressed = val.pressed;
				val = val.value;
			}
			//state += `${i}=${pressed}\n`;

			let lbl = labels.find(lbl => lbl.getValue() == i);
			if (lbl && lbl.getTag() == undefined)
			{
				lbl.getRoot().style.color = pressed ? 'blue' : '';
				if (pressed)
				{
					clickedLabel = lbl;
					break;
				}
			}
		}

		labels.forEach(lbl =>
		{
			if (lbl.getTag() != undefined)
				lbl.getRoot().style.color = '';
		});

		if (clickedLabel == null)
			for (let j = 0; j < gamepad.axes.length; j++)
			{
				//state += `axis[${j}] = ${gamepad.axes[j].toFixed(4)}\n`;
				//console.log(gamepad.axes[j])
				let p = gamepad.axes[j],
					 pressed = 1 - Math.abs(p) < 0.2;

				if (pressed)
				{
					p = parseInt(gamepad.axes[j].toFixed(0))
					let lbl = labels.find(lbl => lbl.getTag() == j && lbl.getValue() == p);
					if (lbl)
					{
						lbl.getRoot().style.color = 'blue';
						clickedLabel = lbl;
						break;
					}
				}
			}


		if (clickedLabel)
		{
			if (clickedLabel == (isRed ? this._redActiveButton : this._blueActiveButton))
			{
				if (!this._CanClickOneButton)
					return;

				let lastGamePadChecked = isRed ? this._RedGamePadeChecked : this._BlueGamePadeChecked;

				if (!lastGamePadChecked)
				{
					if (isRed)
						this._RedGamePadeChecked = (new Date()).getTime();
					else
						this._BlueGamePadeChecked = (new Date()).getTime();
					return;
				}

				lastGamePadChecked = isRed ? this._RedGamePadeChecked : this._BlueGamePadeChecked;

				let dif = (new Date()).getTime() - lastGamePadChecked;

				if (dif < 200)
				{
					if (isRed)
						this._RedGamePadeChecked = (new Date()).getTime();
					else
						this._BlueGamePadeChecked = (new Date()).getTime();

					if (this._checkButtonHold())
						this._onGamePadClick(gamepad, clickedLabel, isRed, true);

					return;
				}
			}

			this._resetButtonHold();

			if (isRed)
				this._redActiveButton = clickedLabel;
			else
				this._blueActiveButton = clickedLabel;

			if (clickedLabel)
				this._onGamePadClick(gamepad, clickedLabel, isRed);
			if (isRed)
				this._RedGamePadeChecked = (new Date()).getTime();
			else
				this._BlueGamePadeChecked = (new Date()).getTime();
		}
	}

	_checkButtonHold(): boolean
	{
		if (this._PressedButtonChecked && ((new Date()).getTime() - this._PressedButtonChecked > 2000))
			return true;

		if (!this._PressedButtonChecked)
			this._PressedButtonChecked = (new Date()).getTime();
		return false;
	}

	_resetButtonHold()
	{
		this._ButtonHoldProcessed = false;
		this._PressedButtonChecked = null;
	}

	updateStatus()
	{
		if (!this.isLive())
			return;

		let gamepads = [];

		for (let gamepad of navigator.getGamepads())
		{
			if (gamepad && gamepad.id.indexOf('Xbox') > -1)
				gamepads.push(gamepad);
		}

		if (gamepads[0])
			this.checkGamePad(gamepads[0], this._leftPadLabels, true);

		if (gamepads[1])
			this.checkGamePad(gamepads[1], this._rightPadLabels, false);

		setTimeout(() => this.updateStatus(), 50);
	}

}
